import script from "./Package.vue?vue&type=script&lang=ts&setup=true"
export * from "./Package.vue?vue&type=script&lang=ts&setup=true"

import "./Package.vue?vue&type=style&index=0&id=f076ea4a&scoped=true&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f076ea4a"]])

export default __exports__